// Components==============
import { defaultTileBarStateValue } from 'components/Exercises/SoundsExercise/components/Row/Row';
import { UserAnswerEntity } from 'components/Exercises/SoundsExercise/SoundsExercise';
import SoundBar from 'components/Layout/SoundBar/SoundBar';
import ExerciseWrapper from 'components/UI/ExerciseWrapper/ExerciseWrapper';
import { SoundType } from 'components/UI/LetterBlock/LetterBlock';
import React, { createContext, useState } from 'react';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import Category from './Category/Category';
import './Tiles.module.scss';
// =========================

type TilesContextType = {
    userAnswers: UserAnswerType;
    setUserAnswers: React.Dispatch<React.SetStateAction<UserAnswerType>>;
    words: WordsWithImages[];
    answer: WordsWithImages;
    dragState: null | DropResult;
    dragging: boolean;
    dragStartId: string;
    toggleIsUpdatedOnClick: boolean;
    activeTileBar: string;
    setActiveTileBar: React.Dispatch<React.SetStateAction<string>>;
    activeTileBarState: SoundType[];
    setActiveTileBarState: React.Dispatch<React.SetStateAction<SoundType[]>>;
    userIsTypingAnswer: boolean;
    setUserIsTypingAnswer: React.Dispatch<React.SetStateAction<boolean>>;
    current: number;
    givenAnswers: UserAnswerType | undefined;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

type UserAnswerType = UserAnswerEntity[];

export const TilesContext = createContext({} as TilesContextType);

const words: WordsWithImages[] = [
    {
        id: 2,
        name: 'stok',
        klanken: ['b', 'b', 'gr', 'b'],
        aantal_klankgroepen: 1,
        klankgroepen: [],
        type: 'woord',
        mk_cluster_voor: 2,
        mk_cluster_achter: 1,
        audio: null,
        phoneme: null,
        created_at: '2021-01-18T08:32:47.000000Z',
        updated_at: '2021-01-18T08:32:47.000000Z',
        pivot: {
            exercise_id: 2,
            word_id: 2,
            string: null,
            category_id: null,
        },
        images: [],
    },
];

export default function Tiles() {
    const [activeTileBar, setActiveTileBar] = useState('initial');

    const [activeTileBarState, setActiveTileBarState] = useState<SoundType[]>(
        defaultTileBarStateValue
    );

    const [dragState, setDragState] = useState<null | DropResult>(null);
    const [dragging, setDragging] = useState(false);

    const [dragStartId, setDragStartId] = useState('');

    const [toggleIsUpdatedOnClick, setToggleIsUpdatedOnClick] = useState(false);

    const [userIsTypingAnswer, setUserIsTypingAnswer] = useState(false);

    const [userAnswers, setUserAnswers] = useState<UserAnswerType>([]);

    const [current, setCurrent] = useState(0);

    const answer = words[current];

    const givenAnswers = [] as UserAnswerType | undefined;

    return (
        <TilesContext.Provider
            value={{
                userAnswers,
                setUserAnswers,
                words,
                answer,
                dragState,
                dragging,
                dragStartId,
                toggleIsUpdatedOnClick,
                activeTileBar,
                setActiveTileBar,
                activeTileBarState,
                setActiveTileBarState,
                userIsTypingAnswer,
                setUserIsTypingAnswer,
                givenAnswers,
                current,
                setCurrent,
            }}
        >
            <DragDropContext
                onDragEnd={(result) => {
                    setDragState(result);
                    setDragging(false);
                }}
                onDragStart={(result) => {
                    setDragStartId(result?.draggableId);
                    setDragging(true);
                }}
            >
                <ExerciseWrapper>
                    <Category
                        name={answer?.name}
                        pivot={answer?.pivot.string}
                    />
                </ExerciseWrapper>
                <SoundBar
                    activeTileBarState={activeTileBarState}
                    setActiveTileBarState={setActiveTileBarState}
                    setToggleIsUpdatedOnClick={setToggleIsUpdatedOnClick}
                    userIsTypingAnswer={!!userAnswers.length}
                    canClick={!userAnswers.length}
                />
            </DragDropContext>
        </TilesContext.Provider>
    );
}
